import SpecificationForm from './scripts';

export default SpecificationForm;
